// ** Redux Imports
import {createSlice, createAsyncThunk, rejectWithValue} from "@reduxjs/toolkit";

// ** Axios Imports
import axios from "axios";
import moment from 'moment';

export const getAllData = createAsyncThunk("appUsers/getAllData", async (arg, {getState}) => {
  const state = getState()
  const response = await axios.get(`${state.users.usersAPI}`);
  if (response.data.results.length > 0) {
    response.data.results.forEach(result => {
      result.last_login = moment(result.last_login).toDate()
      result.creation_date = moment(result.creation_date).toDate()
      result.activation_date = moment(result.activation_date).toDate()
    })
  }
  console.log("users", response.data.results)
  return {
    data: response.data,
  };
});

export const getUser = createAsyncThunk("appUsers/getUser", async (id, {getState}) => {
  const state = getState()
  const response = await axios.get(`${state.users.usersAPI}/${id}`);
  return response.data
});

export const addUser = createAsyncThunk(
    "appUsers/addUser",
    async (user, {dispatch, getState, rejectWithValue}) => {
      try {
        const state = getState()
        const response = await axios.post(`${state.users.usersAPI}?send_email:true`, {...user});
        await dispatch(getAllData());
        return user
      } catch (err) {
        return rejectWithValue(err.response.data)
      }
    }
);

export const editUser = createAsyncThunk("appUsers/editUser", async (user, {rejectWithValue, getState}) => {
      const id = user.id;
      const state = getState()
      delete user.id;

      try {
        const response = await axios.put(`${state.users.usersAPI}/${id}`, {...user});
        return response.data.user
      } catch (err) {
        return rejectWithValue(err.response.data)
      }
    }
);

export const deleteUser = createAsyncThunk("appUsers/deleteUser", async (id, {getState}) => {
      const state = getState()
      const response = await axios.delete(`${state.users.usersAPI}/${id}`, {});
      return response.data
    }
);


export const setAPIUsers = createAsyncThunk("appUsers/setAPIUsers", async (usersAPI, thunkAPI) => {
      return usersAPI
    }
);

// export const getData = createAsyncThunk("appUsers/getData", async (params) => {
//   const response = await axios.get(appConfig.usersAPI.basePath, params);
//   return {
//     params,
//     data: response.data.users,
//     totalPages: response.data.total,
//   };
// });

export const appUsersSlice = createSlice({
  name: "appUsers",
  initialState: {
    users: {
      data: [],
      total: 0,
    },
    selectedUser: null,
    current_error: '',
    usersAPI: null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
        .addCase(setAPIUsers.fulfilled, (state, action) => {
          state.usersAPI = action.payload.usersAPI;
        })
        .addCase(getAllData.fulfilled, (state, action) => {
          state.current_error = ''
          state.users.data = action.payload.data.results;
          state.users.total = action.payload.data.results.length;
        })
        .addCase(getAllData.rejected, (state, action) => {
          state.users.data = []
          state.users.total = 0
          state.current_error = 'Sorry there was a problem with this API, retry later'
        })
        .addCase(getUser.fulfilled, (state, action) => {
          state.selectedUser = action.payload;
        });
  },
});

export default appUsersSlice.reducer;
